import SchemaRules from '@aytm/app/stats/lib/query/schema-rules'
import BasicFilters from '@aytm/app/stats/lib/query/basic-filters'
import MathHelpers from '@aytm/app/stats/lib/util/math'
import ScriptEditor from '@aytm/app/stats/lib/scripts/script-editor'
import ScriptsBasic from '@aytm/app/stats/lib/scripts/scripts-basic'
import ColorsHelper from '@aytm/app/stats/lib/render/colors'
import GoogleUpload from '@aytm/app/stats/lib/io/google-upload'
import { downloadFile } from '@aytm/app/stats/lib/io/file-download'
import { submitHiddenForm } from '@aytm/app/stats/lib/util/dom'
import { getIn } from '@aytm/app/stats/lib/util/helpers'
import CommentsHelpers from '@aytm/app/stats/page/comments/lib/map'

import { SENTIMENTS } from '@aytm/app/stats/page/components/lib/constants'

import { convertQuotas, convertTraits } from '@aytm/app/stats/lib/query/traits'
import { convertCustomVariables } from '@aytm/app/stats/lib/query/variables'
import { convertValuesToTree } from '@aytm/app/stats/lib/util/converter'
import { getTagsList, getGroupsList, getQuestionsList } from '@aytm/app/stats/page/comments/lib/utils'
import SigtestCodec from '@aytm/app/stats/lib/query/sigtest-codec'
import { mountSidebarShell, unmountSidebarShell } from '@aytm/app/stats/preloader/sidebar-shell'

// Side-effect import: the page's window uid is minted on load, so the legacy runtime can read it
// off the global without waiting for a React surface to pull the module in.
import '@aytm/app/stats/lib/page/page-globals'

// import scrollToQuestionListener from '@aytm/app/survey/editor/components/lib/scroll-to-question-rx'

if ('undefined' !== typeof window) {
  window['$STATS'] || (window['$STATS'] = {})

  window['$STATS']['SchemaRules'] = SchemaRules
  window['$STATS']['BasicFilters'] = BasicFilters
  window['$STATS']['Math'] = MathHelpers
  window['$STATS']['ScriptEditor'] = ScriptEditor
  window['$STATS']['ScriptsBasic'] = ScriptsBasic
  window['$STATS']['Comments'] = CommentsHelpers
  window['$STATS']['Colors'] = ColorsHelper
  window['$STATS']['GoogleUpload'] = GoogleUpload
  window['$STATS']['downloadFile'] = downloadFile
  window['$STATS']['submitHiddenForm'] = submitHiddenForm
  window['$STATS']['getIn'] = getIn
  window['$STATS']['convertQuotas'] = convertQuotas
  window['$STATS']['convertTraits'] = convertTraits
  window['$STATS']['convertCustomVariables'] = convertCustomVariables
  window['$STATS']['convertValuesToTree'] = convertValuesToTree

  window['$STATS']['getTagsList'] = getTagsList
  window['$STATS']['getGroupsList'] = getGroupsList
  window['$STATS']['getQuestionsList'] = getQuestionsList

  window['$STATS']['mountSidebarShell'] = mountSidebarShell
  window['$STATS']['unmountSidebarShell'] = unmountSidebarShell

  window['$STATS']['SENTIMENTS'] = SENTIMENTS
  window['$STATS']['SigtestCodec'] = SigtestCodec
}

export {
  SchemaRules,
  BasicFilters,
  MathHelpers as Math,
  ScriptEditor,
  ScriptsBasic,
  CommentsHelpers as Comments,
  ColorsHelper as Colors,
  GoogleUpload,
  downloadFile,
  submitHiddenForm,
  getIn,
  convertQuotas,
  convertTraits,
  convertCustomVariables,
  convertValuesToTree,
  getTagsList,
  getGroupsList,
  getQuestionsList,
  SigtestCodec
  // scrollToQuestionListener as ScrollToQuestion
}
